import { Component } from "react";
import validate from "validate.js";
import groupBy from "lodash/groupBy";
import isEmpty from "lodash/isEmpty";
import each from "lodash/each";
import keys from "lodash/keys";
import { Localize } from "../../../../locale/localization";

validate.formatters.custom = function(errors) {
  const errorsByKey = groupBy(errors, "attribute");
  const errorObj = {};
  keys(errorsByKey).forEach(key => {
    errorObj[key] = errorsByKey[key][0].error;
  });
  return errorObj;
};

validate.validators.validateTargetings = function(value, options, key, attributes) {
  let valid = false;
  if (value && value.selection) {
    each(value.selection, function(selection) {
      if (selection.channel._id !== "" && selection.role !== "") {
        valid = true;
      }
    });
  }
  return valid ? "" : options.message;
};

class BaseFormContainer extends Component {
  state = {
    isSubmitting: false,
    formData: {},
    errors: {},
    touchedFields: [],
    isValid: false
  };

  onSubmit = event => {
    event.preventDefault();

    const { formData, isValid } = this.state;
    if (!isValid) return;

    this.setState({
      isSubmitting: true,
      formError: "",
      submitted: false,
      submitCompleted: false,
      submitFailed: false
    });

    this.doSubmit(formData);
  };

  reset = () => {
    this.setState({
      isSubmitting: false,
      submitted: false,
      submitCompleted: false,
      submitFailed: false,
      errors: {},
      formError: "",
      touchedFields: [],
      isValid: false
    });
  };

  getConstraints() {
    console.error("###getConstraints must be overridden");
  }

  doSubmit = formData => {
    console.error("###doSubmit must be overridden");
  };

  validate = () => {
    const { formData } = this.state;
    let errors = validate(formData, this.getConstraints(), { format: "custom" }) || {};

    //NOTE: range check, too complicated for validatejs or what?
    if (formData.startDate && formData.endDate) {
      const rangeValid = formData.endDate.isSameOrAfter(formData.startDate);
      if (!rangeValid) {
        errors.endDate = Localize("form.date.range.error");
        errors.startDate = Localize("form.date.range.error");
      }
    }
    // 409 error handling special
    if (formData.campaignExistsError) {
      errors.campaignExistsError = Localize("form.campaign.exists.error");
    }

    const isValid = isEmpty(errors);
    this.setState({
      errors,
      isValid
    });
  };

  applyFormDataChange = changes => {
    return Object.assign({}, this.state.formData, changes);
  };

  updateData(event) {
    const target = event.target;
    const { name } = target;
    let { value } = target;
    if (name === "") return;

    if (target.type && target.type === "checkbox") {
      value = target.checked;
    }

    const formData = this.applyFormDataChange({ [name]: value });
    this.setState(
      {
        formData: {
          ...formData
        }
      },
      () => {
        this.validate();
      }
    );
  }

  updateTouchedfields(event) {
    const { name } = event.target;
    // console.log("updateTouchedfields, name", name);
    if (name === "") return;
    const touchedFields = [...this.state.touchedFields.filter(item => item !== name), name];
    this.setState({
      touchedFields
    });
  }

  onBlur = event => {
    this.updateTouchedfields(event);
    this.validate();
  };

  onInputChange = event => {
    const { name } = event.target;
    if (name === "") return;
    // if(this.state.touchedFields.indexOf(name) > -1) {
    //   this.validate();
    // }
    this.updateData(event);
  };

  render() {
    return null;
  }
}

export default BaseFormContainer;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/BaseFormContainer.js